import { render, staticRenderFns } from "./foodTypeAdd.vue?vue&type=template&id=6c490769&"
import script from "./foodTypeAdd.vue?vue&type=script&lang=js&"
export * from "./foodTypeAdd.vue?vue&type=script&lang=js&"
import style0 from "./foodTypeAdd.vue?vue&type=style&index=0&id=6c490769&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports